'use client';

import { type Product } from '@/domain/products/types';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

import ProductDetail from '../../ProductDetailDialog/ProductDetail';
import { ProductPanelHeader } from '../ProductDetailPanel/ProductPanelHeader';
import { ProductPanelFooter } from '../ProductDetailPanel/ProductPanelHeader/ProductPanelFooter';

interface ProductDetailsPageProps {
  detailedProduct: Product;
  isLoggedIn: boolean;
}

const ProductDetailsPage = ({ detailedProduct, isLoggedIn }: ProductDetailsPageProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 63px)',
        overflow: 'hidden',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          p: 4,
          borderBottom: '1px solid',
          borderRadius: '4px 4px 0 0',
          borderColor: 'divider',
          backgroundColor: 'primary.dark',
        }}
      >
        <ProductPanelHeader detailedProduct={detailedProduct} isProductDetailPage={true} />
      </Box>
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <ProductDetail detailedProduct={detailedProduct} isLoggedIn={isLoggedIn} />
      </Box>
      <Box
        sx={{
          flexShrink: 0,
          p: 2,
          display: 'flex',
          justifyContent: !isLoggedIn ? 'flex-end' : 'center',
          gap: 2,
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        {!!detailedProduct?.idProduct && (
          <ProductPanelFooter detailedProduct={detailedProduct} isLoggedIn={isLoggedIn} />
        )}
      </Box>
    </Box>
  );
};

export default ProductDetailsPage;
